import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "../../../View.css";
import SearchView from "../../../widgets/SearchView";
import LearnershipSearchForm from './LearnershipSearchForm';
import { ViewContainer } from "../../../View.jsx";
import ViewUtils from '../../../ViewUtils';

const utils = new ViewUtils();

const headCells = [
    { id: "LearnershipCode", numeric: false, disablePadding: true, label: "Learnership Code" },
    { id: "LearnershipTitle", numeric: false, disablePadding: true, label: "Learnership Title" }
]


class LearnershipSearch extends Component {
    constructor(props) {
        super(props);

        this.searchParameters =
            [
                { Name: "LearnershipCode", Value: "" },
                { Name: "LearnershipTitle", Value: "" }
            ];


        let model =
        {

            LearnershipCode: "",
            LearnershipTitle: ""

        }


        this.state = {
            model: model,
            keyUpSwitch: false,
            selectedLShip: null,
            linkDialogOpen: false
        }
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title={this.props.showTitle === true || utils.isNull(this.props.showTitle) ? 'Learnership Search' : null}>
                <SearchView
                    mode={this.props.mode}
                    headCells={headCells}
                    dataUrl={this.props.dataUrl}
                    onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="LearnershipCode"
                    SecondDescriptionProp="LearnershipTitle"
                    model={this.state.model}
                    searchParameters={this.searchParameters}
                    keyUpSwitch={this.state.keyUpSwitch}
                    mode="lookup"
                    showToolBar={true}
                >
                    <LearnershipSearchForm onKeyUp={(e) => { this.onkeyup(e) }} model={this.state.model} />
                </SearchView>
            </ViewContainer>
        )
    }
}

export default withRouter(
    connect()(LearnershipSearch)
);